import styled from "styled-components";
import IMAGES from "../../constant/IMAGES";
import COLOR from "../../constant/COLOR";

export const WrapperCalendar = styled.div`
  background-image: url(${IMAGES.bgCalendar});
  background-size: 100% 100%;
  height: 100%;
  padding: 50px;
`;
export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 32px 12px;
  gap: 35px;
  border: 3.74px solid ${COLOR.primary300};
  background: ${COLOR.primary50};
  border-radius: 14.97px;
  @media screen and (max-width: 900px) {
    padding: 12px 12px 50px 12px;
  }
`;
export const CircularBackground = styled.div`
  background-image: url(${IMAGES.logoCalendar});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;
export const DayHeader = styled.div`
  font-size: 40px;
  font-family: QuickSand;
  font-weight: 600;
  color: ${COLOR.primary800};
  transform: translateY(15px);
`;

export const DateText = styled.div`
  font-size: 160px;
  font-weight: 400;
  font-family: var(--font-geist-Akeila);
  -webkit-text-stroke: 0.3px;
  color: ${COLOR.accent600};
  transform: translateY(-50px);
`;
export const DateMonth = styled.div`
  font-size: 48px;
  font-weight: 600;
  font-family: QuickSand;
  color: ${COLOR.gray800};

  @media screen and (max-width: 900px) {
    font-size: 14px;
  }
`;
export const Text = styled.div`
  font-size: 40px;
  font-weight: 500;
  font-family: QuickSand;
  color: ${COLOR.gray600};
  @media screen and (max-width: 900px) {
    font-size: 13px;
  }
`;
export const ContainRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;

  @media screen and (max-width: 350px) {
    flex-direction: column;
  }
`;

export const Wrapper = styled.div`
  background: ${COLOR.primary100};
  border: 1.87px solid ${COLOR.primary200};
  border-radius: 15px;
  padding: 16.73px;
  width: 100%;
`;
export const LunarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18.72px;
  border-top: 1.87px solid ${COLOR.borderBg};
  border-bottom: 1.87px solid ${COLOR.borderBg};
  padding: 7.49px 44.92px;
  background: linear-gradient(
    90deg,
    rgba(245, 238, 224, 0) 0%,
    #f5eee0 25.5%,
    #f5eee0 71.5%,
    rgba(245, 238, 224, 0) 100%
  );
`;
export const LunarText = styled.div`
  font-size: 48px;
  font-weight: 600;
  font-family: QuickSand;
  color: ${COLOR.primary900};
  @media screen and (max-width: 900px) {
    font-size: 14px;
  }
`;
export const GridZodiac = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 50px;
  @media screen and (max-width: 575px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
export const Title = styled.div`
  font-family: var(--font-geist-Akeila);
  -webkit-text-stroke: 0.9px;
  font-size: 44px;
  font-weight: 400;
  text-align: left;
  color: ${COLOR.gray900};
  text-transform: uppercase;
  @media screen and (max-width: 575px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const WrapperQr = styled.div`
  background: ${COLOR.primary20};
  border: 2px solid ${COLOR.primary300};
  border-radius: 32px;
  padding: 16px 16px 16px 48px;
  border-radius: 32px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: 30px;
`;

export const TitleZodiac = styled.div`
  font-family: var(--font-geist-Akeila);
  -webkit-text-stroke: 0.5px;
  font-size: 58px;
  font-weight: 400;
  line-height: 31.9px;
  text-align: center;
  color: ${COLOR.gray900};
  text-transform: uppercase;
  transform: translateY(-20px);
  @media screen and (max-width: 575px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const WrapperZodiac = styled.div`
  background-image: url(${IMAGES.bgZodiac});
  background-size: cover;
  border-radius: 16px;
  height: 100%;
  padding: 36px 12px 12px 12px;
  width: 100%;
  background-position: center;
`;

export const WrapperDay = styled.div`
  justify-content: center;
  display: flex;
  align-items: center;
  border-top: 1px solid ${COLOR.borderBg};
  border-bottom: 1px solid ${COLOR.borderBg};
  background: linear-gradient(
    90deg,
    rgba(245, 238, 224, 0) 0%,
    #f5eee0 25.5%,
    #f5eee0 71.5%,
    rgba(245, 238, 224, 0) 100%
  );
  padding: 4px 40px;
  width: 100%;
  transform: translateY(-20px);
`;
